import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-html5-script-loader-modal',
    templateUrl: './html5-script-loader-modal.component.html',
    styleUrls: ['./html5-script-loader-modal.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Html5ScriptLoaderModalComponent {
    private readonly data: any = inject(MAT_DIALOG_DATA);
    progress = toSignal((this.data.progress$ as Observable<number>).pipe(map(p => p * 100)), {initialValue: 0});

}
